import { ORDER_ASIDE_SUBTLE_SURFACE_CLASS } from '@/components/orders/order-aside.styles'
import { Typography } from '@/components/ui/typography'
import { cn, formatCurrency } from '@/lib/utils'
import { Banknote, CreditCard } from 'lucide-react'
import type { ReactNode } from 'react'

interface CustomerHandoffSummaryProps {
  manualTotal: number
  electronicTotal: number
  /** Till or register details for the cash, when Cash Drawer tracking needs them. */
  children?: ReactNode
}

/** The cash or check to hand the customer, and the electronic part that waits for that handoff. */
export function CustomerHandoffSummary({
  manualTotal,
  electronicTotal,
  children,
}: CustomerHandoffSummaryProps) {
  return (
    <div className={cn(ORDER_ASIDE_SUBTLE_SURFACE_CLASS, 'space-y-3 px-4 py-3')}>
      <div className="flex items-center justify-between gap-2">
        <Typography variant="supporting" className="flex items-center gap-2">
          <Banknote className="h-4 w-4" />
          Amount to hand customer
        </Typography>
        <Typography variant="labelStrong">{formatCurrency(manualTotal)}</Typography>
      </div>
      {/* Only when part of the refund goes back electronically: an all-cash handoff has nothing waiting on it. */}
      {electronicTotal > 0 ? (
        <Typography variant="caption">
          Electronic refunds will only be submitted after this confirmation.
        </Typography>
      ) : null}
      {electronicTotal > 0 ? (
        <div className="flex items-center justify-between gap-2">
          <span className="inline-flex items-center gap-2">
            <CreditCard className="h-3.5 w-3.5" />
            <Typography variant="caption">Electronic refund amount</Typography>
          </span>
          <Typography variant="caption">{formatCurrency(electronicTotal)}</Typography>
        </div>
      ) : null}
      {children}
    </div>
  )
}
